import baseIsEqual from "./component-library343.mjs";
import get from "./component-library344.mjs";
import hasIn from "./component-library345.mjs";
import isKey from "./component-library346.mjs";
import isStrictComparable from "./component-library347.mjs";
import matchesStrictComparable from "./component-library342.mjs";
import toKey from "./component-library348.mjs";
var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return objValue === void 0 && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}
export {
  baseMatchesProperty as default
};
